import { onUnmounted, watch } from 'vue'

import type { ConnectionTierTransition } from '@hooks/classroom/connection-tier-live-kit.hook'

import { useConnectionNoticeLiveKit } from '@hooks/classroom/connection-notice-live-kit.hook'
import { useConnectionReportLiveKit } from '@hooks/classroom/connection-report-live-kit.hook'
import { useConnectionTierLiveKit } from '@hooks/classroom/connection-tier-live-kit.hook'
import { refRoom, useRoomLiveKit } from '@hooks/classroom/room-live-kit.hook'

export const useConnectionWatchLiveKit = (): void => {
  const { report } = useConnectionReportLiveKit()
  const { remoteName } = useRoomLiveKit()

  const tiers = useConnectionTierLiveKit()
  const notices = useConnectionNoticeLiveKit()

  const handleTierTransition = (transition: ConnectionTierTransition): void => {
    report(transition)
    notices.handleTransition(transition)
  }

  const startSamplingJoinedRoom = (): void => {
    notices.start()
    tiers.start(handleTierTransition)
  }

  watch(refRoom, (room) => {
    if (!room) {
      tiers.stop()
      notices.clearSide('self')
      return
    }

    startSamplingJoinedRoom()
  }, { immediate: true })

  watch(remoteName, (name) => {
    if (name) return

    notices.clearSide('peer')
  })

  onUnmounted(() => {
    tiers.stop()
    notices.stop()
  })
}
